import { createClient } from '@supabase/supabase-js';

// These environment variables will need to be set in your project
// For development/testing only - replace with environment variables in production
const supabaseUrl = 'https://jkukerivrpdhynuteygv.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImprdWtlcml2cnBkaHludXRleWd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI3NDEyNDgsImV4cCI6MjA1ODMxNzI0OH0.8_OV3eV13L_ok9F63ikZNSs-wgX-fU4pZkWSorvgyh4';

// In production, use:
// const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
// const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing. Please check your environment variables.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
